export default __webpack_public_path__ + "static/media/envoyer.2d170287.svg";